export default __webpack_public_path__ + "static/Artboard-2-ec510ef9624835e47378cab5325a146a.webp";